export default __webpack_public_path__ + "static/media/level-complete-image1.122b9b1e.png";